import { SVGProps } from 'react';

export function KeyIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="10.7348" cy="4.73961" r="2.51999" transform="rotate(1.7418 10.7348 4.73961)" stroke={fill} strokeWidth="1.3" />
      <path d="M8.55873 6.78768L2.04503 12.4039L3.36243 13.9285" stroke={fill} strokeWidth="1.3" strokeLinecap="round" />
      <path d="M4.20508 10.8842L5.17383 12.0053" stroke={fill} strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}
